<template>
  <NoteTagsField
    :model-value="modelValue"
    :company-id="companyId"
    entity-type="vendor"
    :label="label"
    :menu-class="menuClass"
    :select-id-prefix="selectIdPrefix"
    :allow-create="allowCreate"
    @update:model-value="$emit('update:modelValue', $event)"
    @created="$emit('created', $event)"
  />
</template>

<script>
import NoteTagsField from '@/components/NoteTagsField.vue';

export default {
  name: 'VendorNoteTagsField',
  components: {
    NoteTagsField,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    companyId: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: 'Tags',
    },
    menuClass: {
      type: [String, Array, Object],
      default: '',
    },
    selectIdPrefix: {
      type: String,
      default: 'vendor-note-tags',
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'created'],
};
</script>
